import { SadaKCalendar } from './styles';
import { CalendarProps } from 'antd';

type Props = CalendarProps;

const KCalendar = (props: Props) => <SadaKCalendar {...props} />;

export default KCalendar;
